import { Menu as MenuMantine, MenuProps } from "@mantine/core";
import type { FC } from "react";

export const Menu: FC<MenuProps> = ({ children, ...props }) => (
    <MenuMantine {...props} styles={{ dropdown: { width: "150px" } }}>
        {children}
    </MenuMantine>
);
